<template>
  <div class="text-center ma-2">
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="snackbarcolor"
      elevation="24"
    >
      {{ text }}

      <template v-slot:actions>
        <v-btn
          color="white"
          variant="text"
          @click="closesnackbar"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup>
    import { ref, inject, watch } from 'vue'

    //const props = defineProps(['msg'])
    const emit = defineEmits(['closesnackbar'])
    // console.log(props.msgresponse)

    // console.log('This is from show message')
    // console.log(props.showMessage)

    //console.log(props.msg)
    var msg = inject('msg');
    var msgStatus = inject('msgStatus');
    var showMessage = inject('showMessage')
    var snackbar = ref(showMessage.value)
    var snackbarcolor = ref(msgStatus)
    var text = ref(msg)

    async function closesnackbar(){
        console.log('Close snackbar is called')
        snackbar.value = false
        emit('closesnackbar')
    }

    watch(snackbar, async(val)=>{
      if(snackbar.value===false){
        //console.log("Snackbar is closed")
        emit('closesnackbar')
      }
    })
</script>